import { createOptions } from 'options';
import type { BoundState as BoundStateType } from 'modules/campaign/common/types';
import { BlockWidget, UserTitle, BlockWidgetProps } from 'components';
import { fmtMonth } from 'utilities';
import type { EmbeddedUser } from 'modules/core/types';
import { ControlledTableColumns, flexColumn } from 'components/ControlledTable';

export const boundStateOptions = createOptions(['NONE', 'PARTIAL', 'OVERSPENT']);

export const sumProps = {
  width: 100,
  cellProps: { textAlign: 'end' as const },
};

export type RowType = {
  id: string;
  block: BlockWidgetProps;
  manager: EmbeddedUser;
  month: string;
  inoivced: string;
  amount: string;
  remainder: string;
  state: BoundStateType;
  is_overspent: boolean;
};

export const startColumns: ControlledTableColumns<RowType> = [
  flexColumn({
    key: 'block',
    content: 'Block',
    render: ({ block }) => <BlockWidget {...block} link clamp />,
  }),
  flexColumn({
    key: 'manager',
    content: 'Manager',
    minWidth: 120,
    render: ({ manager }) => <UserTitle {...manager} />,
  }),
];

export const endColumns: ControlledTableColumns<RowType> = [
  {
    key: 'month',
    content: 'Month',
    cellProps: {
      className: 'align-middle',
    },
    render: ({ month }) => fmtMonth(month),
    sortable: true,
    width: 90,
  },
  {
    key: 'amount',
    content: 'Amount',
    sortable: true,
    ...sumProps,
  },
  {
    key: 'invoiced',
    content: 'Consumed',
    sortable: true,
    ...sumProps,
  },
  {
    key: 'remainder',
    content: 'Remainder',
    sortable: true,
    ...sumProps,
    cellProps: {
      className: 'text-right align-middle font-weight-bold',
    },
  },
];
